import React from 'react';
import PropTypes from 'prop-types';
import { Info } from '@picsio/icons';

import s from './ConversionDialogPresetInfo.module.scss';

export default function ConversionDialogPresetInfo({ children }) {
  return (
    <div className={s.root} role="note">
      <Info className={s.icon} aria-hidden />
      <div className={s.text}>{children}</div>
    </div>
  );
}

ConversionDialogPresetInfo.propTypes = {
  children: PropTypes.node.isRequired,
};
